module.exports = __webpack_public_path__ + "img/step2.01556ab0.jpg";